import { OmniChatSchema as Schema } from '@omnichat/omnichat-model';

export interface EntityPointer {
  __type: string;
  className: string;
  objectId: string;
}

export interface Retailer extends Schema.Retailer {}
export interface Message extends Schema.Message {}
export interface Campaign extends Schema.Campaign {}
export interface Label extends Schema.Label {}
export interface CampaignMessage extends Schema.CampaignMessage {}
export interface User extends Schema.User {}
export interface Chat extends Schema.Chat {}
export interface MessageTemplate extends Schema.MessageTemplate {}
export interface Team extends Schema.Team {}
export interface CampaignAudienceFileTokenMapping extends Schema.CampaignAudienceFileTokenMapping {}
export interface CampaignMessageToken extends Schema.CampaignMessageToken {}
export interface CampaignAudienceCustomerList extends Schema.CampaignAudienceCustomerList {}
export interface Integration extends Schema.Integration {}
export interface URLShortner extends Schema.URLShortner {}
export interface FeatureFlag extends Schema.FeatureFlag {}

export const ChatPlatform = Schema.ChatPlatform;
export const CampaignAudienceType = Schema.CampaignAudienceType;
export const CampaignStatus = Schema.CampaignStatus;
export const CampaignMessageStatus = Schema.CampaignMessageStatus;
export const URLShortnerType = Schema.URLShortnerType;
export const IntegrationType = Schema.IntegrationType;
export const FeatureFlagStatus = Schema.FeatureFlagStatus;
export const Feature = Schema.Feature;

export const Types = Schema;

export * from './bot';
export * from './dashboard';
